import PropTypes from 'prop-types';

import React from 'react';

import {chemicalBaseTypes, systemTypes} from '../../../helpers/constants.jsx';

import {getTranslatedAssetFileName} from 'helpers/languageHelper';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class Step extends React.Component {
  static propTypes = {
    dataKey: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    productDict: PropTypes.object.isRequired,
    step: PropTypes.number.isRequired,
    value: PropTypes.string,
    language: PropTypes.string,
    requireTranslatedIcon: PropTypes.bool,
  };

  render() {
    let icon = this.props.requireTranslatedIcon ? getTranslatedAssetFileName({filename: this.props.icon,  language: this.props.language}) : this.props.icon;
    let product = this.props.value ? this.props.value : this.props.productDict[this.props.dataKey].currentName;

    if (product.toLowerCase().includes('n/a')) {
      product = product.substring(4);
    }

    return <div className={'steps step-' + this.props.step}>
      <i className={'step-icon bl bl-' + icon}/>
      <div className='form-group'>
        <p>{this.props.name}</p>
        <p className={'product' + (product.length > 10 ? ' long-product' : '')}>{product}</p>
      </div>
    </div>;
  }
}

class MaintenanceSteps extends React.Component {
  static propTypes = {
    pool: PropTypes.object.isRequired,
    productDict: PropTypes.object.isRequired,
    language: PropTypes.string,
    intl: PropTypes.object,
  };

  render() {
    const chlorineBromine = ['step1', 'step2', 'step3'];
    const softswim = ['softswima', 'softswimb', 'softswimc'];
    const salt = ['saltstartup', 'saltweekly', 'saltweekly'];
    const softsoak = ['softsoakcondition', 'softsoaksanitize', 'softsoakshock'];
    let requireTranslatedIcon = false;
    let steps = [];
    let chemicalBaseTypeID = this.props.productDict.sanitizer.chemicalBaseType;
    let productDict = this.props.productDict;
    let {formatMessage} = this.props.intl;

    if (chemicalBaseTypeID === chemicalBaseTypes.saltWaterPool  || chemicalBaseTypeID === chemicalBaseTypes.mineralSpringsPool ||
          productDict.sanitizer.currentName.toLowerCase().includes('saltwater')) {
      requireTranslatedIcon = true;
      steps.push(['sanitizer', formatMessage({id: 'general.sanitizer'}), salt]);
      steps.push(['maintOxidizer', formatMessage({id: 'general.maint.oxidizer'}), salt]);

      if (this.props.pool.typeID === systemTypes.pool || this.props.pool.typeID === systemTypes.swimspa) {
        steps.push(['prevAlgicide', formatMessage({id: 'general.prev.algicide'}), salt]);
      }
    } else if ([
      chemicalBaseTypes.brominePool,
      chemicalBaseTypes.chlorinePool,
      chemicalBaseTypes.synergyPool,
      chemicalBaseTypes.chlorineSpa,
      chemicalBaseTypes.bromineSpa,
      chemicalBaseTypes.synergySpa,
    ].indexOf(chemicalBaseTypeID) !== -1) {
      requireTranslatedIcon = true;
      steps.push(['sanitizer', formatMessage({id: 'general.sanitizer'}), chlorineBromine]);
      steps.push(['maintOxidizer', formatMessage({id: 'general.maint.oxidizer'}), chlorineBromine]);

      if ([chemicalBaseTypes.brominePool, chemicalBaseTypes.chlorinePool, chemicalBaseTypes.synergyPool].indexOf(chemicalBaseTypeID) !== -1) {
        steps.push(['prevAlgicide', formatMessage({id: 'general.prev.algicide'}), chlorineBromine]);
      }
    } else if (chemicalBaseTypeID === chemicalBaseTypes.softswimPool) {
      steps.push(['prevAlgicide', formatMessage({id: 'general.prev.algicide'}), softswim]);
      steps.push(['sanitizer', formatMessage({id: 'general.sanitizer'}), softswim]);
      steps.push(['maintOxidizer', formatMessage({id: 'general.maint.oxidizer'}), softswim]);
    } else if (chemicalBaseTypeID === chemicalBaseTypes.softSoakSpa) {
      requireTranslatedIcon = true;
      steps.push(['sanitizer', formatMessage({id: 'general.sanitizer'}), softsoak]);
      steps.push(['maintOxidizer', formatMessage({id: 'general.maint.oxidizer'}), softsoak]);
      steps.push(['waterlineControl', formatMessage({id: 'general.waterline.control'}), softsoak, 'SoftSoak Stain & Scale Control']);
    }

    let rawOutput = steps.map((step, i) => <Step dataKey={step[0]} step={i + 1} name={step[1]}
      icon={step[2][i]} productDict={this.props.productDict} key={step[0]} value={step[3]}
      language={this.props.language} requireTranslatedIcon={requireTranslatedIcon}/>);

    let output = [];

    for (let i = 0; i < rawOutput.length - 1; ++i) {
      output.push(rawOutput[i]);
      output.push(<div className='steps-arrow' key={'steparrow' + i}/>);
    }
    output.push(rawOutput[rawOutput.length - 1]);

    return <div className='row steps-container'>{output}</div>;
  }
}

export default  injectIntl(MaintenanceSteps);
